import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AgGridAngular } from 'ag-grid-angular';

@Component({
  selector: 'app-full-quote-details',
  templateUrl: './full-quote-details.component.html',
  styleUrls: ['./full-quote-details.component.scss']
})
export class FullQuoteDetailsComponent implements OnInit {

  @ViewChild('agGrid', { static: false }) agGrid!: AgGridAngular;
  
  details: any = {};
  customer_details: any = {};
  customer_address_details: any = {};
  internal_sales_details: any = {};
  financial_details: any = {};
  quote_details: any = {};

  constructor(private route: ActivatedRoute, private http: HttpClient) { };

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const serializedObject = params['data'];
      this.details = JSON.parse(serializedObject);
      const customer_details_url = `/api/contacts/contact_details.php?uuid=${this.details.customer_contact_uuid}`;
      const sales_details_url = `/api/contacts/contact_details_profiles.php?table=internal_sales&uuid=${this.details.internal_sale_uuid}`;
      const financial_details_url = `/api/quotes/quote_details.php?uuid=${this.details.lading_spot_quote_uuid}`;
      this.http.get<any>(customer_details_url).subscribe(response => {
        if (response) {
          this.customer_details = response;
          if (response['contact_addresses'][0]) {
            this.customer_address_details = response['contact_addresses'][0]
          }
        }
      });

      this.http.get<any>(sales_details_url).subscribe(response => {
        if (response) {
          this.internal_sales_details = response;
        }
      });
      const financialParamsGetRequest = {
        name: 'financial',
      };
      this.http.get<any>(financial_details_url, { params: financialParamsGetRequest }).subscribe(response => {
        if (response[0]) {
          this.financial_details = response[0];
        }
      });
      const quoteParamsGetRequest = {
        name: 'quote',
      };
      this.http.get<any>(financial_details_url, { params: quoteParamsGetRequest }).subscribe(response => {
        this.quote_details = response;
      });
      console.log(JSON.parse(serializedObject));
    })
  }

    

  getStatus(text: string): string {
    if(text == '1') {
      return 'Open'
    }
    else if(text == '2') {
      return 'Accepted'
    }
    else if(text == '3') {
      return 'Rejected'
    }
    else {
      return '-';
    }
  } 
}
